export default (slider) => {
  // Append Exit Button
  // const exitButton = document.createElement('button');
  // exitButton.classList.add('swiper-exit-button visually-hidden');
  // exitButton.setAttribute('aria-label', 'Exit Slider');
  // exitButton.textContent = 'Exit Slider';
  // slider.appendChild(exitButton);

  // // Add keyboard listener for exiting the slider
  // slider.addEventListener('keydown', (e) => {
  //   if (e.key === 'Escape' || e.keyCode === 27) {
  //     // Move focus to an element outside the slider
  //     const focusTarget = document.querySelector('[data-main-nav]') || document.body;
  //     focusTarget.focus();
  //   }
  // });

   // Add keyboard listener for exiting the slider
   slider.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      // Find the next section after the slider
      const nextSection = slider.closest('section')?.nextElementSibling;

      // Check if the next section exists and is focusable
      if (nextSection) {
        // Find the first focusable element in the next section
        const focusableInNextSection = nextSection.querySelector(
          'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
        );

        // Focus the first focusable element in the next section, or the section itself
        if (focusableInNextSection) {
          focusableInNextSection.focus();
          focusableInNextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          nextSection.setAttribute('tabindex', '-1'); // Make the section focusable if needed
          nextSection.focus();
          nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        console.warn('No next section found to move focus to.');
      }
    }
  });
};
